<!-- 首页 -->
<template>
  <div id="app"
       @click="tagMenuShow=false">
    <el-container class="container">
      <!-- 左 -->
      <!-- 左侧图标 -->
      <el-aside :width="isCollapse?'65px':'180px'"
                class="aside">
        <div class="logo">
          <img src="../assets/images/logo.png"
               alt="">
          <!-- <h1 v-show="!isCollapse">数据库</h1> -->
        </div>
        <!-- 左侧菜单栏 -->
        <el-menu :default-active="currentPath"
                 class="menu-left"
                 :collapse="isCollapse"
                 background-color="#fff"
                 text-color="#4b5563"
                 active-text-color="#005bac"
                 :unique-opened="true"
                 router>
          <template v-for="item in menuList">
            <el-submenu :index="item.path"
                        :key="item.path"
                        v-if="item.children&&item.visiable">
              <!-- 一级菜单里面包含二级菜单 -->
              <template slot="title">
                <i :class="'iconfont icon-'+item.meta.icon"></i>
                <span> {{ item.meta.title }}</span>
              </template>
              <!-- 二级菜单 -->
              <template v-for="menu in item.children">
                <el-menu-item class="second"
                              :index="menu.path"
                              :key="menu.path"
                              v-if="!menu.hidden&&menu.visiable">
                  <i :class="'iconfont icon-'+menu.meta.icon"></i>
                  {{ menu.meta.title }}
                </el-menu-item>
              </template>
            </el-submenu>
            <!-- 一级菜单 -->
            <el-menu-item :index="item.path"
                          :key="item.path"
                          v-show="item.visiable"
                          v-if="!item.children&&!item.hidden&&item.visiable">
              <i :class="'iconfont icon-'+item.meta.icon"></i>
              <span slot="title">{{ item.meta.title }}</span>
            </el-menu-item>
          </template>
        </el-menu>

      </el-aside>
      <!-- 右 -->
      <el-main>
        <!-- 顶部导航 -->
        <el-row type="flex"
                justify="space-between"
                align="middle">
          <!-- 折叠 -->
          <!-- 导航栏 -->
          <el-col :xs="7"
                  :sm="10"
                  :md="13"
                  :lg="16">
            <div class="title"> {{$route.meta.title}}</div>
          </el-col>
          <!-- 头像 -->
          <el-col :xs="6"
                  :sm="5"
                  :md="4"
                  :lg="3"
                  style="text-align: right;">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                <span>{{ this.txname }}</span>
                <i class="el-icon-caret-bottom el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="clearfix"
                                  @click.native="tc">
                  退出登录
                  <el-badge class="mark" />
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
          <!-- <el-col :xs="6"
                  :sm="5"
                  :md="4"
                  :lg="3">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                <img class="avatar"
                     :src="avatarUrl"
                     alt="" />
                <i class="el-icon-caret-bottom el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="clearfix"
                                  @click.native="tc">
                  退出登录
                  <el-badge class="mark" />
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col> -->
        </el-row>
        <!-- 展示区域 -->
        <div class="zs">
          <transition name="fade"
                      mode="out-in">
            <router-view :key="time"></router-view>
          </transition>
        </div>
      </el-main>
    </el-container>
  </div>
</template>


<script>
import managementItem from '@/views/management-center/managementItem/index.vue'
import projectVisit from '@/views/management-center/projectVisit/index.vue'
import projectAnalysis from '@/views/management-center/projectAnalysis/index.vue'
export default {
  data() {
    return {
      //管理员信息
      adminxx: {
        type: '1'
      },
      isCollapse: true,
      //用户名字
      txname: '',
      //用户头像
      avatarUrl: require('@/assets/images/avatar-default.svg'),
      // 个人信息
      userInfo: [],
      // 全部数据
      routerList: [],
      // 左侧菜单栏
      menuList: [
        {
          name: '/index',
          path: '/index',
          hidden: false,
          roles: ['0', '1'],
          component: 'index',
          visiable: false,
          meta: {
            title: '数据看板',
            icon: 'data1',
            noCache: false
          }
        },
        {
          name: '/managementItem',
          path: '/managementItem',
          hidden: false,
          roles: ['0', '1'],
          component: managementItem,
          visiable: false,
          meta: {
            title: '管理项目',
            icon: '24gf-folder',
            noCache: false
          }
        },
        // {
        //   name: '/projectVisit',
        //   path: '/projectVisit',
        //   hidden: false,
        //   roles: ['0', '1'],
        //   component: projectVisit,
        //   visiable: false,
        //   meta: {
        //     title: '访问项目',
        //     icon: 'icon-',
        //     noCache: false
        //   }
        // },
        {
          name: '/projectAnalysis',
          path: '/projectAnalysis',
          hidden: true,
          roles: ['0', '1'],
          component: projectAnalysis,
          visiable: false,
          meta: {
            title: '项目分析',
            noCache: false
          }
        }
      ],
      // 当前菜单全部数据的下标
      menuActiveIndex: 0,
      activeName: 'second',
      tagList: [{ title: '数据看板', path: '/index', status: true }],
      currentPath: '/',
      tagMenuShow: false,
      x: 0,
      y: 0,
      time: Date.now(),
      icon: true
    }
  },
  mounted() {
    if (this.$equipment() != null) {
      this.isCollapse = true
    } else {
      this.isCollapse = false
      this.icon = false
    }
    //如果currentTagList有缓存，则初始化tagList
    const currentTagList = sessionStorage.getItem('currentTagList')
    if (currentTagList) this.tagList = JSON.parse(currentTagList)
    //初始化当前的路径currentPath
    this.currentPath = this.$route.path
    this.tx()
    // this.getRouters(),
    this.setRoleShow()
    this.parseAuth()
  },

  watch: {
    // 监听路由的改变
    $route(route) {
      //更新currentPath当前路径
      this.currentPath = route.path
      //先把所有状态改变false
      this.tagList.forEach((el) => (el.status = false))
      //当前路由
      const { path, meta } = route
      //判断当前路由路径是否存在tagList数组中
      let tag = this.tagList.find((el) => el.path == path)
      if (tag) {
        tag.status = true
      } else {
        //如果不存在则添加到tagList数组中
        tag = { title: meta.title, path: path, status: true }
        this.tagList.push(tag)
      }
      //把当前的路径存放到本地中
      if (tag.path === '/') {
        sessionStorage.setItem('currentTagList', JSON.stringify([tag]))
      }
      if (tag.path !== '/') {
        sessionStorage.setItem('currentTagList', JSON.stringify([{ title: '数据看板', path: '/index', status: true }, tag]))
      }
    }
  },
  methods: {
    parseAuth() {
      var roles = window.sessionStorage.getItem('role')
      if (roles == 0) {
        for (var i = 1; i <= 15; i++) {
          window.sessionStorage.setItem('auth-' + i, 3)
        }
        return
      }
      var authList = window.sessionStorage.getItem('auth')
      var auths = JSON.parse(authList)
      var authL = []
      auths.forEach((auth) => {
        authL.push(auth.type)
        window.sessionStorage.setItem('auth-' + auth.type, auth.attribute)
      })
      this.menuList.forEach((element) => {
        if (element.authType == undefined) {
          return
        }
        if (!authL.includes(element.authType)) {
          element.visiable = false
        }
      })
    },
    setRoleShow() {
      var roles = window.sessionStorage.getItem('role')
      this.menuList.forEach((element) => {
        if (element.roles.includes(roles)) {
          element.visiable = true
        }
        if (element.children != undefined && element.children.length > 0) {
          element.children.forEach((item) => {
            if (item.roles.includes(roles)) {
              item.visiable = true
            } else {
              item.visiable = false
            }
          })
        }
      })
    },
    tc() {
      window.sessionStorage.removeItem('role')
      window.sessionStorage.removeItem('token')
      window.sessionStorage.removeItem('currentTagList')
      for (var i = 1; i <= 14; i++) {
        window.sessionStorage.removeItem('auth-' + i)
      }
      window.sessionStorage.removeItem('auth')
      window.sessionStorage.removeItem('tokenStartTime')
      this.$router.push('/')
    },
    //头像信息
    async tx() {
      const { data: res } = await this.$http.get('/brain/admin/getAdminInfo')
      this.txname = res.data.username
      // if (res.data.avatar !== null && res.data.avatar !== undefined && res.data.avatar !== '') {
      //   this.avatarUrl = this.$url + res.data.avatar
      // }
    },
    //处理tag的滚动
    tagScroll(event) {
      const wheelDelta = event.wheelDelta
      const wrap = this.$refs.scroll.wrap
      //在当前滚动条的位置基础上做移动
      wrap.scrollLeft = wrap.scrollLeft + wheelDelta / 4
    }

    // 个人信息
    // async getInfo() {
    //   const { data: res } = await this.$http.get('/getInfo')
    //   if (res.code != 200) return this.$message.error(res.msg)
    //   this.userInfo = res.user
    //   // console.log(res)
    // },
    // // 请求页面路由信息
    // async getRouters() {
    //   const { data: res } = await this.$http.get('/getRouters')
    //   if (res.code != 200) return this.$message.error(res.msg)
    //   this.routerList = res.data

    //   this.menuList = this.routerList[this.menuActiveIndex].children
    // },
    // handleClick(name) {
    //   this.menuActiveIndex = name.index
    //   this.getRouters()
    // }
  }
}
</script>

<style lang='scss' scoped>
// 设置切换动画
.fade-level-active,
.fade-enter-active {
  transition: all 0.5s;
}

.avatar {
  width: 30px;
  height: 30px;
}

.fade-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-level-to {
  opacity: 0;
  transform: translateX(30px);
}

.container {
  width: 100vw;
  height: 100vh;
}

.aside {
  // background: #304156;
}

// 左边logo
.logo {
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;

  img {
    width: 90%;
    margin-right: 10px;
  }
}

.menu-left {
  border-right: none;

  .second {
    background: #1f2d3d !important;
    min-width: 0;
  }

  .second:hover {
    background: #001528 !important;
  }
}

// 右边折叠
.hidn-show {
  span {
    width: 100%;
    font-size: 20px;
  }
}

// 头像
.el-dropdown-link {
  margin-left: 25px;
}

// 顶部可关闭标签页
.tagbar {
  box-shadow: 0 1px 3px 0 rgb(0 0 0 /12%), 0 0 3px 0 rgb(0 0 0 /4%);

  .list {
    padding-left: 14px;
    height: 34px;
    line-height: 34px;

    .item {
      margin-right: 5px;
    }

    .active {
      background: #1890ff;
      color: #fff;

      &::before {
        content: '';
        display: inline-block;
        width: 8px;
        height: 8px;
        background: #fff;
        border-radius: 50%;
      }
    }
  }
}

// 展示区域
.zs {
  margin-top: 10px;
  height: 100vh;
  padding: 0px 20px;
}
.title {
  font-weight: 600;
  margin: 15px;
}
.el-main {
  background-color: #f8fafc;
  padding: 10px;
}

.iconfont {
  margin-right: 5px;
  font-size: 23px;
}

//tag操作列表
.contextmenu {
  position: absolute;
  background: #fff;
  width: 88px;
  box-shadow: 2px 2px 3px 0 rgb(0 0 0 / 30%);
  font-size: 12px;
  color: #999;
  text-align: center;
  z-index: 999;

  li {
    padding: 10px;

    &:hover {
      background: #eeeeee;
    }
  }
}
</style>